<template>
  <p> Expenses </p>
</template>

<script>
  export default {
    name: 'ExpensesView',
    
    data: () => ({
 
    }),
  }
</script>